export default __webpack_public_path__ + "static/media/anna.f4ac9002.png";